import { useQuery } from '@tanstack/react-query';
import { createAgendasApi } from '../api/events/agendasApi';
import type { AgendaIndex, Agenda } from '../types/agenda.types';

export const useAgendas = (eventSlug: string) => {
  const api = createAgendasApi(eventSlug);

  return useQuery<AgendaIndex[], Error>({
    queryKey: ['agendas', eventSlug],
    queryFn: () => api.getAgendas(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!eventSlug
  });
};

export const useAgenda = (eventSlug: string, agendaId: string | null) => {
  const api = createAgendasApi(eventSlug);

  return useQuery<Agenda, Error>({
    queryKey: ['agenda', eventSlug, agendaId],
    queryFn: () => {
      if (!agendaId) throw new Error('Agenda ID is required');
      return api.getAgenda(agendaId);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!eventSlug && !!agendaId
  });
};